import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

import { StyledTitle } from './BrandOrderTitle.styles';
import { BrandOrderTitleProps } from './BrandOrderTitle.types';

export const BrandOrderTitle = ({ isMobile, title, onClose }: BrandOrderTitleProps) => {
  return (
    <StyledTitle isMobile={isMobile}>
      {title}
      {isMobile && (
        <IconButton onClick={onClose} sx={{ ml: 1 }}>
          <Close />
        </IconButton>
      )}
    </StyledTitle>
  );
};
